export default __webpack_public_path__ + "static/dw-dark-5fc7953856c79a68793e0b6f5154c6f9.png";